import { render, staticRenderFns } from "./HooksFilterBar.vue?vue&type=template&id=5ec70127&scoped=true"
import script from "./HooksFilterBar.vue?vue&type=script&lang=js"
export * from "./HooksFilterBar.vue?vue&type=script&lang=js"
import style0 from "./HooksFilterBar.vue?vue&type=style&index=0&id=5ec70127&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec70127",
  null
  
)

export default component.exports